export const LEAVE_QUERY_KEYS = {
  LEAVE_BALANCE: 'leaveBalance',
  WELL_BEING_LEAVE_CREDITS: 'wellBeingLeaveCredits',
  LEAVES: 'leaves',
  CALCULATE_LEAVE: 'calculateLeave',
} as const;

export const ROLE_QUERY_KEYS = {
  ROLES: 'roles',
  PERMISSIONS: 'permissions',
  ROLES_PERMISSIONS: 'rolesPermissions',
  MY_ROLE: 'myRole',
} as const;

export const USER_INFO_QUERY_KEYS = {
  USER_INFO: 'userInfo',
} as const;

export const FISCAL_YEAR_QUERY_KEYS = {
  BY_COUNTRY: 'fiscalYearByCountry',
} as const;

export const ATTENDANCE_QUERY_KEYS = {
  SUMMARY: 'summary',
  ROSTER: 'roster',
  CALENDAR: 'attendanceCalendar',
  WORK_STATUS_SUMMARY: 'workStatusSummary',
  UNFREEZE_REQUESTS: 'unfreezeRequests',
} as const;

export const USER_QUERY_KEYS = {
  TEAMS: 'userTeams',
  ALLOCATIONS: 'userAllocations',
  LIST: 'users',
  DETAIL: 'user',
  ROLES: 'userRoles',
  CURRENT_ALLOCATIONS: 'userCurrentAllocations',
  BOOKING_ALLOCATION: 'userBookingAllocation',
  WORK_STATUS: 'userWorkStatus',
  RESIGNATIONS: 'resignations',
  LEAVE_ISSUER_HISTORY: 'leaveIssuerHistory',
  TEAM_MANAGER_HISTORY: 'teamManagerHistory',
  TEAM_MEMBERS: 'teamMembers',
  ISSUEE_COUNT: 'issueeCount',
  PEOPLE_FINDER: 'peopleFinder',
  RESOURCE: 'resource',
} as const;

export const GOAL_QUERY_KEYS = {
  USER_GOALS: 'userGoals',
  USER_GOALS_SUMMARY: 'userGoalsSummary',
  USER_FEEDBACKS: 'userFeedbacks',
  GOAL_FEEDBACKS: 'goalFeedbacks',
} as const;

export const SKILL_QUERY_KEYS = {
  GLOBAL_RATINGS: 'globalRatings',
  SELECTED_SKILLS: 'selectedSkills',
  ALL: 'skills',
  ALL_V1: 'skillsV1',
  DETAIL: 'skill',
  CATEGORIES: 'skillCategories',
  END_LEVEL: 'endLevelSkills',
  ALL_SKILLS: 'allSkills',
} as const;

export const QUICK_LINK_QUERY_KEYS = {
  QUICK_LINKS: 'quickLinks',
} as const;

export const ASSET_QUERY_KEYS = {
  ASSETS_BY_ID: 'assets',
} as const;

export const PULSE_QUERY_KEYS = {
  OFFBOARD_FEEDBACK: 'offboardFeedback',
} as const;

export const USER_STAKEHOLDERS_QUERY_KEYS = {
  USER_STAKEHOLDERS: 'userStakeHolders',
} as const;

export const DEPARTMENT_QUERY_KEYS = {
  ALL: 'departments',
} as const;

export const DESIGNATION_QUERY_KEYS = {
  ALL: 'designations',
  DETAIL: 'designation',
} as const;

export const DESIGNATION_AREA_QUERY_KEYS = {
  ALL: 'designationAreas',
} as const;

export const ENGAGEMENT_STATUS_QUERY_KEYS = {
  ALL: 'engagementStatuses',
} as const;

export const EVENT_QUERY_KEYS = {
  LIST: 'events',
  DETAIL: 'event',
} as const;

export const NOTICE_QUERY_KEYS = {
  LIST: 'notices',
  BOARD: 'noticeBoard',
  DETAIL: 'notice',
} as const;

export const REMINDER_QUERY_KEYS = {
  LIST: 'reminders',
  DETAIL: 'reminder',
} as const;

export const HOLIDAY_QUERY_KEYS = {
  LIST: 'holidays',
  DETAIL: 'holiday',
} as const;

export const TEAM_SUMMARY_QUERY_KEYS = {
  SUMMARY: 'teamSummary',
} as const;

export const DASHBOARD_QUERY_KEYS = {
  INDUSTRIES: 'industries',
  PROJECTS_WITH_INDUSTRY: 'projectsWithIndustry',
} as const;
